import { render } from "./SelecionarTipoImpressaoBoletos.vue?vue&type=template&id=eae77b20&ts=true"
import script from "./SelecionarTipoImpressaoBoletos.vue?vue&type=script&lang=ts"
export * from "./SelecionarTipoImpressaoBoletos.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__